<div *ngIf="authorizedUser else authUser" class="nav-block">
	<span *ngIf="!userService.userIsSupport" [routerLink]="['devconf/profile']" (click)="close()"
		class="link">Profile</span>
	<span (click)="logout()">Logout</span>
</div>

<ng-template #authUser>
	<div class="login-wrapper">

		<app-login (closeDialog)="close()"></app-login>

		<div class="nav-block">
			<span>registrieren</span>
			<span>Lost Password</span>
		</div>

	</div>
</ng-template>